import React, { createContext, ReactNode, useContext, useState } from 'react';

import { isBrowser } from '../helpers/is-browser';

interface UserInfo {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  category: string;
  verificationStatus: boolean;
}

interface UserContextType {
  user: UserInfo | null;
  setUser: (user: UserInfo | null) => void;
}

const UserContext = createContext<UserContextType | undefined>(undefined);

export const UserProvider = ({ children }: { children: ReactNode }) => {
  const [user, setUser] = useState<UserInfo | null>(null);

  return (
    <UserContext.Provider value={{ user, setUser }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUser = (): UserContextType => {
  const context = useContext(UserContext);

  if (!context) {
    if (typeof window === 'undefined') {
      return {
        user: null,
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        setUser: () => {},
      };
    }
    throw new Error('useUser must be used within a UserProvider');
  }
  return context;
};
